import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { PaginatedLoadingTable } from '@artprov/design-system'
import { GrillaSinResultados } from '@/common/components/mensajes/GrillaSinResultados'
import { RESPONSE_HEADERS } from '@/common/utils/constants/headers'
import { cuentasAllColumns } from '../constants/columns'

const CUENTAS_EMPTY_STATE_MESSAGES = {
  DEFAULT: {
    TITLE: 'No tenés cuentas asociadas',
    DESCRIPTION: 'Clickeá "Asociar nueva cuenta" para agregar una.',
  },
  FILTRO: {
    TITLE: 'No se encontraron resultados',
    DESCRIPTION: 'Modificá la búsqueda para ver las cuentas que buscás.',
  },
  ERROR: {
    TITLE: 'No se pudieron cargar las cuentas',
    DESCRIPTION: 'Intentá nuevamente más tarde.',
  },
}

const CUENTAS_STATUS_MESSAGES = {
  SOLICITUD_EN_PROCESO: 'Solicitud en proceso',
}

export default function CuentasTable({ headers, tableData, onPageChange, isLoading, hasSearchFilter, error }) {
  const rows = isLoading ? [] : tableData
  const showEmpty = rows.length === 0

  let mensajesSinResultados = CUENTAS_EMPTY_STATE_MESSAGES.DEFAULT
  if (hasSearchFilter) mensajesSinResultados = CUENTAS_EMPTY_STATE_MESSAGES.FILTRO
  if (error) mensajesSinResultados = CUENTAS_EMPTY_STATE_MESSAGES.ERROR

  const normalizedHeaders = useMemo(() => {
    const totalRaw = headers?.[RESPONSE_HEADERS.TOTAL_COUNT]
    const total = Number(totalRaw)
    return {
      [RESPONSE_HEADERS.TOTAL_COUNT]: Number.isFinite(total) ? total : 0,
    }
  }, [headers])

  return (
    <div className="tabla-fix sin-checks">
      <div className="w-full overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0">
        <div className="min-w-[800px] md:min-w-0">
          <PaginatedLoadingTable
            columns={cuentasAllColumns}
            data={rows}
            headers={normalizedHeaders}
            isLoading={isLoading}
            loadingIcon="progress_activity"
            loadingText={CUENTAS_STATUS_MESSAGES.SOLICITUD_EN_PROCESO}
            loadingIconVariant="primary"
            loadingIconClassName="animate-spin ease-in-out text-primary-10"
            textClassName="flex text-primary-10"
            textVariant="subtitle1"
            onPageChange={onPageChange}
            uniqueKey="id"
            initialPageSize={10}
            showPagination={true}
          />
        </div>
      </div>

      {showEmpty && !isLoading && (
        <div className="flex flex-col items-center mt-8 md:mt-12 lg:mt-16">
          <GrillaSinResultados
            icon="error"
            iconStyles="text-warning-20"
            title={mensajesSinResultados.TITLE}
            titleStyles="text-primary-10"
            description={mensajesSinResultados.DESCRIPTION}
          />
        </div>
      )}
    </div>
  )
}

CuentasTable.propTypes = {
  headers: PropTypes.object.isRequired,
  tableData: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  hasSearchFilter: PropTypes.bool,
  error: PropTypes.string,
}
